<template>
    <div class="page">
        <div class="base">
            <img src="https://cosimg.cdbost.cn/cdboost/sy/hzjm003.jpg" alt="">
        </div>
        <div class="base">
            <img src="https://cosimg.cdbost.cn/cdboost/sy/hzjm04.jpg" alt="">
        </div>
        <div class="base">
            <img src="https://cosimg.cdbost.cn/cdboost/sy/hzjm05.jpg" alt="">
        </div>
        <div class="base">
            <img src="https://cosimg.cdbost.cn/cdboost/sy/hzjm07.jpg" alt="">
        </div>
        <div class="base">
            <img src="https://cosimg.cdbost.cn/cdboost/sy/hzjm08.jpg" alt="">
        </div>
        <div class="base">
            <img src="https://cosimg.cdbost.cn/cdboost/sy/hzjm09.jpg" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        name: "service"
    }
</script>

<style scoped  lang="scss">
    .base {
        color: #333333;
        position: relative;
        overflow: hidden;
        background: white;
    }
</style>